import stockScoreChart from '../charts/stock-score.js';
import technicals from './technicals.js';

export default function(res, target, data) {
	technicals(res, target, data, 'stock-score', stockScoreChart);
}
